<template>
  <section class="opportunity cover image">
    <v-img
      :src="imageUrl"
      :height="height"
      :min-height="imageUrl ? '' : height"
      lazy-src="https://picsum.photos/10/6?image=1021"
      :class="{
        overlay: overlayMode !== 'none',
        'overlay--navbar': overlayMode === 'navbar',
      }"
    >
      <template slot="placeholder">
        <v-layout fill-height align-center justify-center ma-0>
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-layout>
      </template>
    </v-img>

    <div class="slot--top-left">
      <slot name="top-left"> </slot>
    </div>

    <div class="slot--top-right">
      <slot name="top-right"> </slot>
    </div>
  </section>
</template>

<script>
// Helpers
import _ from 'lodash'

const defaultHeight = function() {
  switch (this.$vuetify.breakpoint.name) {
    case 'xs':
      return '150px'
    case 'sm':
      return '250px'
    case 'md':
      return '400px'
    default:
      return '60vh'
  }
}

export default {
  // created() {
  //  if (this.imageUrl) this.$store.dispatch('images/fetch', this.imageUrl)
  // },

  props: {
    opportunity: { type: Object, required: true },
    height: { type: [String], default: defaultHeight },
    overlayMode: {
      type: String,
      default: 'full',
      validator: value => ['full', 'navbar', 'none'].includes(value),
    },
  },

  computed: {
    imageUrl() {
      const a = _.get(this, 'opportunity.coverImage')
      const b = _.get(this, 'opportunity.organization.coverImage')

      return a || b
    },

    image() {
      if (!_.get(this, '$store.state.images.images')) return ''

      return this.$store.state.images.images[this.imageUrl]
    },
  },
}
</script>

<style lang="scss">
.opportunity.cover.image {
  width: 100%;

  .slot--top-left {
    position: absolute;
    top: 0px;
    left: 0px;
  }

  .slot--top-right {
    position: absolute;
    top: 0px;
    right: 0px;
  }

  .overlay::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
  }

  .overlay.overlay--navbar::after {
    height: 0;
  }

  @media (min-width: 960px) {
    .overlay.overlay--navbar::after {
      height: 64px;
    }
  }
}
</style>
